import { render, staticRenderFns } from "./view_right_tip.vue?vue&type=template&id=174e81b2&scoped=true"
import script from "./view_right_tip.vue?vue&type=script&lang=js"
export * from "./view_right_tip.vue?vue&type=script&lang=js"
import style0 from "./view_right_tip.vue?vue&type=style&index=0&id=174e81b2&prod&scoped=true&lang=scss"
import style1 from "./view_right_tip.vue?vue&type=style&index=1&id=174e81b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174e81b2",
  null
  
)

export default component.exports